<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage, Layout, PageHeader, flashMessage },
  data() {
    return {
      title: "Permission Assign to Role",
      items: [
        {
          text: "Admin Setting",
          href: "/",
        },
        {
          text: "Permission Assign",
          active: true,
        },
      ],
      roles: [],
      permissions: [],
      permssionCategories: [],
      submitform: false,
      submitted: false,
      permission_id: [],
      cat_permission: [],
      errors: null,
      selectAll: false,
        visible:false,
        message:"",
      form: {
        role_id: "",
      },
    };
  },
  validations: {
    form: {
      role_id: {
        required,
      },
    },
  },
  mounted() {
    this.getRoleList();
    this.getPermissionList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async getPermissionList() {
      try {
        axios
          .get("/api/permission_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.permissions = response.data.data;
              var pCatArr = [];
              this.permissions.map(function (value, key) {
                if (pCatArr.indexOf(value.category) == -1) {
                  pCatArr.push(value.category);
                }
              });
              this.permssionCategories = pCatArr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getRoleList() {
      try {
        axios
          .get("/api/role_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.roles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/assign_permission", {
          permission_id: this.permission_id,
          role_id: this.form.role_id,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
              this.$swal("Good job!", "Permission Assigned", "success");
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
            if (error.response != undefined) {
                this.errors = error.response.data.errors;
            }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    getPermissionListOnChange(value) {
      try {
        axios
          .get("/api/permission/role", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              roleid: event.target.value,
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.permission_id = [];
              var assignedPermission = response.data.data;
              if (assignedPermission.length > 0) {
                for (let i in assignedPermission) {
                  this.permission_id.push(assignedPermission[i].permission_id);
                }
              } else {
                this.permission_id = [];
              }
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    catCheckFuntion(event) {
      var _that = this;
      if (event.target.checked) {
        var checkboxList = this.$el.querySelectorAll("." + event.target.value);
        for (let i in checkboxList) {
          if (checkboxList[i].value != undefined) {
              var e=checkboxList[i].value;
              var fields=_that.permission_id;
              var exists = fields.some(function(field) {
                  return field == e;
              });

           if(!exists){
               _that.permission_id.push(parseInt(e));
           }
          }
        }
      } else {
        var checkboxList = this.$el.querySelectorAll("." + event.target.value);

        for (let i in checkboxList) {
          if (checkboxList[i].value != undefined) {
              var k;
              for(k=0 ; k<_that.permission_id.length;k++){
                  if(this.permission_id[k]==checkboxList[i].value){
                      _that.permission_id.splice(k,1);
                  }
              }
          }
        }
      }
    },
    selectAllCheckbox() {
      this.permission_id = [];
      if (!this.selectAll) {
        for (let i in this.permissions) {
          this.permission_id.push(this.permissions[i].id);
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="permissionAssign" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="role_id">Select Role</label>
                    <select
                      id="role_id"
                      name="role_id"
                      v-model="form.role_id"
                      class="form-control"
                      v-on:change="getPermissionListOnChange"
                      :class="{ 'is-invalid': submitted && $v.form.role_id.$error }">
                        <option value="" disabled style="display:none" selected>Select Role</option>
                      <option v-for="(role, index) in roles" v-if="role.type=='admin'" :value="role.id"
                            v-bind:key="index">{{ role.name }}
                    </option>
                    </select>
                    <div
                      v-if="submitted && $v.form.role_id.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.role_id.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Select Permission</label>
                  </div>
                  <ul class="permissionUl">
                    <li>
                      <a href="javascript: void(0);" style="margin-bottom: 5px;">
                        <span>Select all </span><input type="checkbox" v-model="selectAll" @click="selectAllCheckbox()" />
                      </a>
                    </li>
                  </ul>
                  <ul class="permissionUl">
                    <li v-for="(pCate, index) in permssionCategories" v-bind:key="index" :id="'li_' + index">
                      <a href="javascript: void(0);">
                        <span>{{ pCate }} </span><input class="form-check-input"  type="checkbox" :value="pCate.replace(/ /g,'_').toLowerCase()" :id="pCate.replace(/ /g,'_').toLowerCase()" style="position: relative; margin-left: 3px;" v-on:click="catCheckFuntion($event)" />
                      </a>
                      <ul class="sub-menu" aria-expanded="true">
                        <li
                          v-for="permission in permissions"
                          v-if="permission.category == pCate"
                          v-bind:key="permission.id"
                          :id="'subli_' + permission.id"
                        >
                          <div class="form-check mb-3">
                              <input class="form-check-input" :class="pCate.replace(/ /g,'_').toLowerCase()" v-model.number="permission_id" type="checkbox" :value="permission.id" :id="'defaultCheck_'+permission.id"  />
                              <label class="form-check-label" :for="'defaultCheck_'+permission.id">{{ permission.name }}</label>
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>

                </div>
              </div>
              <button class="btn btn-primary" type="submit">Save</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
